<template>
  <div>

    <p v-if="message !== null">
      {{message}}
    </p>

    <template v-if="isRacesVisible">
      <p class="mb-1">
        Количество заездов: {{raceAmount | getFormattedNumber}}
      </p>

      <rush-race-previews-table
        :rushId="rushId"
        :races="races"
        :offset="offset"
        class="mb-4"
      />

      <b-pagination-nav
        v-if="pageAmount > 1"
        :number-of-pages="pageAmount"
        :link-gen="linkGen"
        first-number
        last-number
        use-router
        class="mb-4"
      />
    </template>

    <loading-indicator v-if="isLoading"/>

  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import LoadingIndicator from './LoadingIndicator.vue';
import RushRacePreviewsTable from './RushRacePreviewsTable.vue';

const PAGE_SIZE = 100;

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'RushRaces',

  components: {
    LoadingIndicator,
    RushRacePreviewsTable,
  },

  props: {
    rushId: {
      type: Number,
      required: true,
    },

    page: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,

      /** @type {?number} */
      raceAmount: null,

      /** @type {?Array} */
      races: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {?string} */
    message() {
      if(!this.isLoadedNormal) {
        return null;
      }

      if(this.raceAmount === 0) {
        return 'No races.';
      }

      return null;
    },

    /** @returns {number} */
    pageAmount() {
      const raceAmount = this.raceAmount;
      if(raceAmount === null) {
        return 0;
      }

      return Math.ceil(raceAmount / PAGE_SIZE);
    },

    /** @returns {number} */
    offset() {
      const prevPageAmount = this.page - 1;
      return prevPageAmount * PAGE_SIZE;
    },

    /** @returns {boolean} */
    isRacesVisible() {
      const races = this.races;
      if(races === null) {
        return false;
      }

      return races.length > 0;
    },
  },

  created() {
    this.loadRaces();
  },

  watch: {
    page() {
      this.loadRaces();
    },
  },

  methods: {
    loadRaces() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const rushId = this.rushId;
      const url = `/rush/${rushId}/races`;

      const params = {
        limit: PAGE_SIZE,
      };

      const offset = this.offset;
      if(offset > 0) {
        params.offset = offset;
      }

      HTTP.get(
        url,
        {params: params}
      )
      .then(response => {
        const data = response.data.data;

        if(data === null) {
          this.loadingStatus = LOADING_STATUS__ERROR;
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.raceAmount = data.raceAmount;
        this.races = data.races;

        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },

    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
  },
};
</script>
